import { isDate } from "date-fns";
import React from 'react';

export function validateAssessment({ uid, intensity, odourLevel, location, characters, startDate, startTime, endTime, isReceiveUpdate, email, canContact, isParticipate, name, phone, address }) {
    const validatorErrors = []
    if (!uid) {
        validatorErrors.push({
            message: 'A user id must be provided to submit am odour assessment',
            key: 'uid'
        })
    }

    if (intensity === 0) {
        validatorErrors.push({
            message: 'Please select the strength of the odour',
            key: 'intensity'
        })
    }

    if (!location || !location.geometry || !location.formatted_address) {
        validatorErrors.push({
            message: 'Please select the location where you experienced the odour ',
            key: 'location'
        })
    }

    if (intensity > 1) {

        if (odourLevel === null) {
            validatorErrors.push({
                message: 'Please indicate if you are ok with the level of odour',
                key: 'odourLevel'
            })
        }


        if (!characters || !characters.length) {
            validatorErrors.push({
                message: 'Please provide atleast one odour character',
                key: 'characters'
            })
        }

        if (!startTime || !isDate(startTime)) {
            validatorErrors.push({
                message: 'Please select the time when you experienced the odour',
                key: 'startDate'
            })
        }

        if (!startDate || !isDate(startDate)) {
            validatorErrors.push({
                message: 'Please select the date when you experienced the odour',
                key: 'startDate'
            })
        } else if (startTime && (startTime > new Date())) {
            validatorErrors.push({
                message: 'You cannot select a future date',
                key: 'startDate'
            })
        }

        if (endTime && (endTime > new Date())) {
            validatorErrors.push({
                message: 'You cannot select a future date',
                key: 'endDate'
            })
        }

        if (startTime && endTime && (startTime > endTime)) {
            validatorErrors.push({
                message: 'Smell start date/time should not be greater that stop date/time',
                key: 'endDate'
            })
        }

        if (isReceiveUpdate === 'yes' && !email) {
            validatorErrors.push({
                message: 'Please enter your email to receive updates.',
                key: 'email'
            })
        }

        if (canContact === 'yes' && (!name || !phone)) {
            validatorErrors.push({
                message: 'Please enter your name and phone number.',
                key: 'contact'
            })
        }
        if (isParticipate) {
            if (!name || (typeof name === 'string' && name.trim() === '')) {
                validatorErrors.push({
                    message: 'You must enter your name',
                    key: 'name'
                })
            }
            if (!phone || (typeof phone === 'string' && phone.trim() === '')) {
                validatorErrors.push({
                    message: 'You must enter a valid phone number',
                    key: 'phone'
                })
            }
            if (!address || (address && typeof address === 'string' && address.trim() === '')) {
                validatorErrors.push({
                    message: 'You must enter an address',
                    key: 'address'
                })
            }
        }

        if (intensity === 1 && odourLevel === 'objectionable') {
            validatorErrors.push({
                message: 'Please use the arrows to find the option that best describes how the smell affects you',
                key: 'intensity'
            })
        }
    }

    return validatorErrors;
}


function keyArrayToObj(ms) {
    if (!ms) {
        return {};
    }
    return ms.reduce((acc, val) => {
        acc[val.key] = val;
        return acc
    }, {});
}

// append the validator classlist if it exists in the messages
export function validatorClassList(originalClassName, validatorName, messages) {
    const o = keyArrayToObj(messages);

    if (!o[validatorName]) {
        return originalClassName
    } else {
        return originalClassName + ' question-section__error';
    }
}

export function ValidatorComponent({ name, messages }) {
    const o = keyArrayToObj(messages);

    if (!o[name]) {
        return (<div className="error-section"></div>)
    }
    return (<div className="error-section">
        {o[name].message}
    </div>)
}

export function ValidatorSummaryComponent({ messages }) {
    const items = messages.map(obj => {
        return (<li key={obj.message} className="error-summary__item">{obj.message}</li>)
    })

    if (messages.length === 0) {
        return (<div className="error-summary"></div>)
    }
    return (<div className="error-summary">
        Before we can process your report, you must fix the following issues:
        <ul>
            {items}
        </ul>
    </div>)
}